<script>
import Headline from '@/components/Helpers/Headline.vue'
import { prices } from '@/helpers/prices'
import axios from 'axios'

import DatePicker from 'vue2-datepicker'
import UserSelect from '@/components/Helpers/UserSelect.vue'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'UsersStatisticsPage',
  components: { UserSelect, Headline, DatePicker },
  mixins: [prices],
  data () {
    return {
      is_loading: false,
      page_sizes: [10, 30, 50, 100],
      date_range: [],
      queryNavigation: {
        date_from: null,
        date_to: null,
        search: null,
        sort_by: 'orders_count',
        sort_direction: 'desc',
        page: 1,
        per_page: 10
      },
      pagination: {
        page: 1,
        last_page: 0
      },
      headers: [
        {
          title: 'ID',
          sortable: true,
          class: 'id_seller',
          value: 'dropshipper_id'
        },
        {
          title: 'Продавец',
          sortable: false,
          class: 'full_name_seller',
          value: 'dropshipper_name'
        },
        {
          title: 'Кол-во заказов',
          sortable: true,
          class: 'balance_seller',
          value: 'orders_count'
        },
        {
          title: 'Кол-во забранных',
          sortable: true,
          class: 'balance_seller',
          value: 'picked_count'
        },
        {
          title: 'Чистая прибыль ',
          sortable: true,
          class: 'full_name_seller',
          value: 'total_profit'
        },
        {
          title: '% Возвратов',
          sortable: true,
          class: 'balance_seller',
          value: 'return_percent'
        }
      ],
      items: []
    }
  },
  computed: {
    ...mapState('users', ['dropshippers']),
    sortBy: {
      get () {
        return this.queryNavigation.sort_by
      },
      set (val) {
        this.queryNavigation = {
          ...this.queryNavigation,
          sort_by: val,
          page: 1
        }
      }
    },
    sortDirection: {
      get () {
        return this.queryNavigation.sort_direction
      },
      set (val) {
        this.queryNavigation = {
          ...this.queryNavigation,
          sort_direction: val,
          page: 1
        }
      }
    },
    perPage: {
      get () {
        return this.queryNavigation.per_page
      },
      set (val) {
        this.queryNavigation = {
          ...this.queryNavigation,
          per_page: val,
          page: 1
        }
      }
    }
  },
  watch: {
    queryNavigation: {
      deep: true,
      handler (val, oldVal) {
        console.log('changed')
        this.getStatistics()
      }
    },
    date_range (v) {
      this.queryNavigation.date_from = v[0]
      this.queryNavigation.date_to = v[1]
      this.queryNavigation.page = 1
    }
  },
  methods: {
    ...mapActions('users', ['getDropshippers']),
    ...mapMutations('users', {
      setDropshipperFilters: 'setDropshipperFilters',
      searchDrop: 'setSearch'
    }),
    getStatistics () {
      this.is_loading = true
      this.items = []
      axios.get('api/admin/statistic/sellers', {
        params: this.queryNavigation
      }).then(res => {
        this.is_loading = false
        this.items = res.data.data
        this.pagination = {
          page: res.data.current_page,
          last_page: res.data.last_page
        }
      })
    },
    fetchDropshippers (search) {
      this.searchDrop(search)
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getDropshippers()
      }, 500)
    },
    selectDropshipper (data) {
      this.queryNavigation.dropshipper_id = data.id
      this.getStatistics()
    }
  },
  created () {
    const to = new Date()
    const from = new Date()
    from.setDate(to.getDate() - 90)

    this.date_range = [from, to]
    this.queryNavigation.date_from = from
    this.queryNavigation.date_to = to
    this.getStatistics()
  }
}
</script>

<template>
  <section class="table_box all_sellers">
    <div style="margin-top: 18px;" class="container flx">
      <div style="display: flex; justify-content: space-between" class="table_head">
        <span class="page_title">Статистика по пользователям</span>
      </div>
      <div class="wrap_btn flx" style="margin-top: 12px">
        <div style="display: flex; justify-content: space-between">
          <date-picker
              :disabled="is_loading"
              style="margin-top: 10px;margin-left: 10px;"
              v-model="date_range"
              type="date"
              range
              format="DD.MM.YYYY"
              placeholder="Выберите период"
          >
          </date-picker>
        </div>
      </div>
    </div>
    <!--     Продавец | Кол-во Заказы | Кол-во забранных | Чистая Прибыль | % возвратов |-->
    <div class="container">
      <div class="table_body table_all_sellers">
        <div class="top_table flx">
          <div class="search_box flx">
            <div class="choose_seller flx">
              <p>Продавец:</p>
              <user-select
                  class="mini-select"
                  style="min-width: 225px;margin-right: 10px"
                  :default-id="null"
                  default-name="Все"
                  :items="dropshippers"
                  @search="fetchDropshippers"
                  @select="selectDropshipper"
                  @active-input="fetchDropshippers"
                  :is-filter="true"
              ></user-select>
            </div>
          </div>
          <div class="pagination flx">
            <div class="flx">
              <p>Строк:</p>
              <brew-select
                  class="select-pagination select-dropshipper-per_page"
                  style="margin-left:10px;width: 100px"
                  v-model="perPage"
                  :clearable="false"
                  :options="page_sizes"
              >
              </brew-select>
            </div>
            <paginate
                style="margin-left: 20px"
                class="flx"
                v-model="queryNavigation.page"
                :page-count="pagination.last_page"
                :page-range="3"
                :margin-pages="2"
                :prev-text="'<'"
                :next-text="'>'"
            >
            </paginate>
          </div>
        </div>
        <div class="bot_table">
          <headline :headers="headers"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDirection"
          />
          <div class="row_list">
            <div
                style="cursor: auto"
                v-for="item in items"
                :key="'item-'+item.dropshipper_id"
                class="row flx"
            >
              <div class="id_seller">
                <a href="#">{{ item.dropshipper_id }}</a>
              </div>
              <div class="full_name_seller">
                <span>{{ item.dropshipper_name }}</span>
              </div>
              <div class="balance_seller">
                <span>{{ item.orders_count }}</span>
              </div>
              <div class="balance_seller">
                {{ item.picked_count }}
              </div>
              <div class="full_name_seller">
                {{ item.total_profit | asPrice }}
              </div>
              <div class="balance_seller">
                {{ item.return_percent }} %
              </div>
            </div>
          </div>
        </div>
        <div v-if="is_loading && items.length === 0" style="text-align: center; padding: 20px">Загрузка данных...</div>
        <div v-if="!is_loading && items.length === 0" style="text-align: center; padding: 20px">Данные не найдены!</div>
      </div>
    </div>
  </section>
</template>

<style scoped>

</style>
